import _ from 'lodash';
import React from 'react';

import Button from 'components/Button';
import Warning from 'components/Warning';
import ErrorBlock from 'components/ErrorBlock';
import {default as Modal, withModal} from 'components/Modal';
import {MODALS, fetchBooking, removeSecondaryTenant} from 'ducks/bookings';

import './styles.css';

class RemoveSecondaryTenantModal extends React.Component<any> {
  componentDidMount() {
    const {bookingId, locationRef} = this.props;

    this.props.fetchBooking(
      {locationRef, bookingId},
      this.props.storeDataExtraActions(data => ({tenants: data.tenants}))
    );
  }

  removeSecondaryTenant = () => {
    const {bookingId, refetchExtraActions} = this.props;

    const successExtraActions = [
      ...this.props.closeModalExtraActions,
      ...refetchExtraActions()
    ];

    const failureExtraActions = this.props.storeDataExtraActions(
      ({errors}) => ({errors})
    );

    this.props.removeSecondaryTenant(
      {bookingId},
      successExtraActions,
      failureExtraActions
    );
  };

  render() {
    const {tenants, errors} = this.props.data;
    const secondaryTenant = _.head(
      _.filter(tenants, tenant => !tenant.isPrimary)
    );
    const showGoCardlessWarning =
      !_.isNil(secondaryTenant) &&
      (secondaryTenant.hasGocardlessCustomerThatIsCurrentForTheBooking ||
        secondaryTenant.hasGocardlessInvitationThatIsCurrentForTheBooking);

    return (
      <Modal
        show={true}
        onClose={this.props.closeModal}
        className="RemoveSecondaryTenantModal"
        type={Modal.SUB_MEDIUM}>
        <Modal.Header>
          <h3 className="heading">Remove Secondary Tenant</h3>
        </Modal.Header>
        <Modal.Body>
          {!_.isNil(secondaryTenant) &&
            showGoCardlessWarning && (
              <Warning>
                Removing this member from the booking will also remove their
                GoCardless mandates and invitations. Are you sure you want to
                continue?
              </Warning>
            )}
          {!_.isNil(secondaryTenant) &&
            !showGoCardlessWarning && (
              <Warning>
                Are you sure you want to remove the secondary tenant?
              </Warning>
            )}
          {errors && <ErrorBlock>{errors._error}</ErrorBlock>}
        </Modal.Body>
        <Modal.Footer>
          <Button white onClick={this.props.closeModal}>
            No
          </Button>
          <Button blue onClick={this.removeSecondaryTenant}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToModalData = () => ({});
const mapDispatchToModalProps = {
  fetchBooking,
  removeSecondaryTenant
};

export default withModal(
  MODALS.REMOVE_SECONDARY_TENANT,
  mapStateToModalData,
  mapDispatchToModalProps
)(RemoveSecondaryTenantModal);
